import { DigitalSurface } from 'src/apollo/onlineOrdering'
import { Channel } from 'src/public/js/siteUtilities'

import ToastProduct from './ToastProduct'

export const getDigitalSurface = (
  product: ToastProduct,
  channel?: Channel
): DigitalSurface => {
  if (channel === Channel.ECOMM) {
    return DigitalSurface.OoEcommerce
  }

  switch (product) {
    case ToastProduct.OOBasic:
      return DigitalSurface.OoBasic
    case ToastProduct.OOPro:
      return DigitalSurface.OoPro
    case ToastProduct.Sites:
      return DigitalSurface.Websites
    case ToastProduct.ToastLocal:
      return DigitalSurface.Local
    case ToastProduct.OOEcommerce:
      return DigitalSurface.OoEcommerce
    case ToastProduct.FreeOOToastLocal:
      return DigitalSurface.Local
    case ToastProduct.ToastApp:
      return DigitalSurface.Local
  }
}

export const getIsCustomDomain = (hostname: string): boolean => {
  return (
    !hostname.endsWith('toasttab.com') &&
    !hostname.endsWith('toast.site') &&
    !hostname.endsWith('toast.ventures')
  )
}
